const TENCENT_CHAT_TIMEOUT_MESSAGES = new Set([
  '[TencentCloudChat] timeout',
  '请求超时'
])

export function isTencentChatTimeout(error) {
  return TENCENT_CHAT_TIMEOUT_MESSAGES.has(error?.message)
}

export async function runTencentChatOperation(operation) {
  try {
    return await operation()
  } catch (error) {
    if (isTencentChatTimeout(error)) return false
    throw error
  }
}

export function logoutTencentChat(client) {
  return runTencentChatOperation(async () => {
    await client.logout()
    return true
  })
}
